<script setup>
import { computed } from 'vue'

const props = defineProps({
  open: Boolean,
  kind: { type: String, default: 'like' }
})
defineEmits(['cancel', 'confirm'])

const copy = computed(() => props.kind === 'imageVideo'
  ? {
      mark: '✦',
      title: '登录后使用 AI视频',
      description: '登录账号后即可生成并查看 AI视频，是否现在就去登录？'
    }
  : {
      mark: '♥',
      title: '登录后点赞',
      description: '登录账号后即可点赞并同步记录，是否现在就去登录？'
    })
</script>

<template>
  <div
    v-if="open"
    class="login-prompt-layer"
    role="presentation"
    @pointerdown.self="$emit('cancel')"
  >
    <section
      class="login-prompt-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="login-prompt-title"
      aria-describedby="login-prompt-description"
      @pointerdown.stop
    >
      <div class="login-prompt-dialog__mark" aria-hidden="true">{{ copy.mark }}</div>
      <h2 id="login-prompt-title">{{ copy.title }}</h2>
      <p id="login-prompt-description">{{ copy.description }}</p>
      <footer>
        <button type="button" @click="$emit('cancel')">暂不</button>
        <button class="is-primary" type="button" @click="$emit('confirm')">去登录</button>
      </footer>
    </section>
  </div>
</template>
